import React from 'react';
import { capitalize, toLower } from 'lodash';
import Modal from 'Views/Components/Modal/Modal';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import { ProgramVersionEntity } from 'Models/Entities';

interface ProgramDetailsModalProps {
	isOpen: boolean,
	programVersion: ProgramVersionEntity,
	onCloseModal: () => void
}

const ProgramDetailsModal = (props: ProgramDetailsModalProps) => {
	const {
		isOpen,
		programVersion,
		onCloseModal,
	} = props;

	return (
		<Modal
			className="program-details-modal information-modal"
			label="Program details modal"
			isOpen={isOpen}
			onRequestClose={onCloseModal}
		>
			<div className="modal__header">
				<h4>About the {toLower(window.lexicon.program)}</h4>
			</div>
			<div className="modal__message">
				<h5 className="program-name">
					{`${programVersion.program.code} 
					${programVersion.program.displayName}`}
				</h5>

				<div className="information-modal__section">
					<h6>Formal abbreviation</h6>
					<p>{programVersion.program.formalAbbreviation}</p>
				</div>

				<div className="information-modal__section">
					<h6>Duration</h6>
					<p>{programVersion.duration}</p>
				</div>

				<div className="information-modal__section">
					<h6>Description</h6>
					<p>{programVersion.description}</p>
				</div>
			</div>
			<div className="modal__actions">
				<Button
					key="cancel"
					onClick={onCloseModal}
					type="button"
					colors={Colors.Primary}
					display={Display.Outline}
				>
					Close
				</Button>
			</div>
		</Modal>
	);
};

export default ProgramDetailsModal;
